import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { DocumentService } from '@app/shared/services/vault/document.service';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { AddVaultDialogComponent } from '@app/shared/component/add-vault-dialog/add-vault-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { vaultStoreActions } from '@app/root-store/vault-store';
import { Store } from '@ngrx/store';
import { RootStoreState } from '@app/root-store';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'vault-selection-form',
  templateUrl: './vault-selection-form.component.html',
  styleUrl: './vault-selection-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VaultSelectionFormComponent implements OnInit, OnDestroy {
  @Input() files: any;
  @Input() vault_list: any[] = [];
  @Input() currentFormId: any;
  @Input() vaultStateObject;
  @Input() currentuserId;
  @Output() vaultSelected = new EventEmitter<any>();
  searchText = '';
  ai_suggested_item: any = null;
  is_loading = true;
  selected_vault: any;
  subscription = new Subscription();
  constructor(
    private _documentService: DocumentService,
    private store$: Store<RootStoreState.State>,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private cd: ChangeDetectorRef
  ) {}
  ngOnInit(): void {
    this.vaultSuggestion();
  }
  vaultSuggestion() {
    this.subscription.add(
      this._documentService.getVaultUserFormVaultSuggestion(this.currentFormId).subscribe((res) => {
        res = res.filter((x) => x.suggestion_type === 'vault_selection');
        if (res.length > 0) {
          let vault = this.vault_list.find((x) => x.id === res[0].vault_id);
          if (vault) {
            this.ai_suggested_item = vault;
            this.selected_vault = vault;
          } else {
            if (res[0]?.new_vault_name) {
              this.ai_suggested_item = {
                id: res[0].vault_id ? res[0].vault_id : -1,
                name: res[0].new_vault_name,
                type: res[0].new_vault_type,
                new_entity_type: res[0].new_entity_type,
              };
              this.selected_vault = {
                id: res[0].vault_id ? res[0].vault_id : -1,
                name: res[0].new_vault_name,
                type: res[0].new_vault_type,
                new_entity_type: res[0].new_entity_type,
              };
            }
          }
          if (this.files.suggested_vault_id) {
            let vault = this.vault_list.find((x) => x.id === this.files.suggested_vault_id);
            if (vault) {
              this.selected_vault = vault;
            }
          }
          if (this.files.suggested_new_vault_name) {
            this.selected_vault = {
              id: -1,
              name: this.files.suggested_new_vault_name,
              type: this.files.suggested_new_vault_type,
              new_entity_type: this.files.suggested_new_vault_type,
            };
          }
          this.cd.detectChanges();
        }
        this.is_loading = false;
        this.cd.detectChanges();
      })
    );
  }
  onSaveVault() {
    if (this.selected_vault.id == -1) {
      const modalRef = this.dialog.open(AddVaultDialogComponent, {
        panelClass: 'full-window-dialog-2',
        disableClose: true,
        autoFocus: false,
        data: {
          user_id: this.currentuserId,
          fromDiscovery: false,
          vault_suggestion_details: this.ai_suggested_item,
        },
      });
      this.subscription.add(
        modalRef.afterClosed().subscribe((res) => {
          if (res.message) {
            this.selected_vault.id = res.data.id;
            this.saveVault();
            this.store$.dispatch(new vaultStoreActions.GetVaultRequestAction(this.vaultStateObject?.userId, false));
          }
        })
      );
    } else {
      this.saveVault();
    }
  }
  saveVault() {
    this.subscription.add(
      this._documentService
        .updateVaultForVaultUserForm([
          {
            vault_id: this.selected_vault.id,
            vault_user_form_id: this.currentFormId,
          },
        ])
        .subscribe((res) => {
          this.toastr.success(`Saved to ${this.selected_vault.name} successfully`);
          this.vaultSelected.emit(this.selected_vault);
        })
    );
  }
  clearSearchAction() {
    this.searchText = '';
  }
  onInputChange(searchValue: string) {
    this.searchText = searchValue;
  }
  addNewVault() {
    const modalRef = this.dialog.open(AddVaultDialogComponent, {
      panelClass: 'full-window-dialog-2',
      disableClose: true,
      autoFocus: false,
      data: {
        user_id: this.vaultStateObject?.userId,
        fromDiscovery: false,
      },
    });
    this.subscription.add(
      modalRef.afterClosed().subscribe((res) => {
        if (res.message) {
          this.selected_vault = res.data;
          this.onSaveVault();
          this.store$.dispatch(new vaultStoreActions.GetVaultRequestAction(this.vaultStateObject?.userId, false));
        }
      })
    );
  }
  updateVaultSelection(vault) {
    let data;
    if (vault.id !== -1) {
      data = {
        suggested_vault_id: vault.id,
        ids: [this.files.vault_user_form_uploads_id],
      };
    } else {
      data = {
        suggested_new_vault_name: vault.name,
        suggested_new_vault_type: vault.type,
        ids: [this.files.vault_user_form_uploads_id],
      };
    }
    this.subscription.add(this._documentService.updateSetVaultPreference(data).subscribe((data) => {}));
  }
  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
